var getThemeClassNames = function getThemeClassNames(inverted, themeProps) {
  if (!themeProps) {
    if (inverted === undefined) {
      return [];
    }
    return inverted ? ['cogs-themed--base', 'cogs-themed--inverted'] : ['cogs-themed--base'];
  }
  if (themeProps.inverted === undefined) {
    return [];
  }
  if (themeProps.theme === 'ai') {
    return themeProps.inverted ? ['cogs-themed--ai', 'cogs-themed--inverted'] : ['cogs-themed--ai'];
  }
  return themeProps.inverted ? ['cogs-themed--base', 'cogs-themed--inverted'] : ['cogs-themed--base'];
};

export { getThemeClassNames };
